import React from 'react'
import AnimatedBrandMark from './AnimatedBrandMark'
import AnimatedCtaLink from './AnimatedCtaLink'

const FinalCtaPanel = ({
  id,
  headingId,
  titleFr,
  titleEn,
  bodyFr,
  bodyEn,
  href,
  label,
  labelEn,
  activatingLabel,
  activatingLabelEn,
}) => (
  <section
    className="final-cta-panel octo-brand-owner"
    id={id}
    aria-labelledby={headingId}
    data-final-cta=""
    data-final-cta-layout="icon-copy-action"
  >
    <div className="final-cta-panel__icon" data-final-cta-column="icon" aria-hidden="true">
      <AnimatedBrandMark variant="cta" />
    </div>

    <div className="final-cta-panel__copy" data-final-cta-column="copy">
      <h2 id={headingId}>
        <span lang="fr">{titleFr}</span>
        <small lang="en">{titleEn}</small>
      </h2>
      <div className="final-cta-panel__languages">
        <p lang="fr">
          <span className="final-cta-panel__language-tag" aria-hidden="true">FR</span>
          <span>{bodyFr}</span>
        </p>
        <p lang="en">
          <span className="final-cta-panel__language-tag" aria-hidden="true">EN</span>
          <span>{bodyEn}</span>
        </p>
      </div>
    </div>

    <div className="final-cta-panel__action" data-final-cta-column="action">
      <AnimatedCtaLink
        className="final-cta-panel__button"
        variant="panel"
        href={href}
        label={label}
        labelEn={labelEn}
        activatingLabel={activatingLabel}
        activatingLabelEn={activatingLabelEn}
      />
    </div>
  </section>
)

export default FinalCtaPanel
